import React from "react";
import "./loader.css";

function Loader() {
  return (
    <div className="loader-overlay">
      <div className="fancy-loader-container">
        <div className="ring"></div>
        <div className="ring"></div>
        <div className="ring"></div>
        <div className="secure-dot"></div>
        <span className="loader-text">Securing Connection...</span>
      </div>
    </div>
  );
}

export default Loader;